module.exports = "https://cdn.thelire.com/ins/resource/lh_special_one_like@3x.8e59e7b2542c3a2140bc2fc99a7f6c0b.png";